import { FC } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { MyTourCard, MyTourPreview } from 'entities/tour/ui/my-tour-card'

import { Button } from 'shared/ui/button'

import { getTourDocumentPath } from '../../model/get-tour-document-path'

import s from './styles.module.scss'

interface Props {
  tours: MyTourPreview[]
}

export const MyTours: FC<Props> = ({ tours }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (!tours.length) return null

  return (
    <section className={s.block}>
      <h2 className={clsx(s.title, 'bold-16')}>{t('my_tours')}</h2>
      <div className={s.list}>
        {tours.map((tour) => (
          <MyTourCard
            key={tour.id}
            tour={tour}
            onClick={() => navigate(getTourDocumentPath(tour.id, tour.status))}
          />
        ))}
      </div>
      {tours.length >= 2 && (
        <Button
          type="button"
          variant="dark"
          borderRadius="md"
          className={clsx(s.orders, 'semi-bold-17')}
          onClick={() => navigate(RoutingPaths.myOrders.path())}
        >
          {t('my_orders')}
        </Button>
      )}
    </section>
  )
}
